import _ from 'lodash';
import moment from 'moment';
import { Filters } from '../store/interfaces';

function localCalendarDayToUtcDateString(dateStr: string, boundary: 'start' | 'end'): string {
  const m = moment(dateStr, 'YYYY-MM-DD', true);
  if (!m.isValid()) {
    return dateStr;
  }
  const local = boundary === 'start' ? m.clone().startOf('day') : m.clone().endOf('day');
  return local.utc().format('YYYY-MM-DD');
}

export function buildPayoutSearchFilterQuery(filters: Filters): string {
  const localToday = moment().format('YYYY-MM-DD');
  const isTodayFilter = !!filters.from && !!filters.to && filters.from === filters.to && filters.from === localToday;
  const utcToday = moment.utc().format('YYYY-MM-DD');

  let filterParam = '';
  Object.keys(filters).forEach(key => {
    const raw = filters[key];
    if (!raw) {
      return;
    }

    let value = raw;
    if (key === 'from') {
      value = isTodayFilter ? utcToday : localCalendarDayToUtcDateString(raw, 'start');
    } else if (key === 'to') {
      value = isTodayFilter ? utcToday : localCalendarDayToUtcDateString(raw, 'end');
    }

    filterParam += filterParam ? '&' : '';
    filterParam += `${_.snakeCase(key)}=${encodeURIComponent(value)}`;
  });
  return filterParam;
}
